<template>
  <div class="learn-page">
    <!-- 听音排图 -->
    <LLearnAudioSort
      v-if="ELEMENT_TYPES.AUDIO_SORT === SOURCE_TO_ELEMENT[currentELementType]"
      @submit="onSubmit"
      @back="onELementBackEmit"
    />
    <div v-else class="l-learn-container">
      <div class="l-learn-left">
        <!-- 标题 -->
        <LLearnTitle @back="onTitleBackEmit" />
        <!-- 内容区域 -->
        <div class="l-learn-area">
          <!-- 设计图部分 -->
          <LLearnDesign></LLearnDesign>
          <!--
            @submit 元素提交记录
            @next 题类型元素使用下一个
          -->
          <!-- 问答
            - 整讲测评/扩展
            - 自读测评
            - 跟读测评
            - ABC选项
            - ABC讲解测评
          -->
          <LLearnQuestionAnswer v-if="isQuestionAndAnswer" @next="onNext" v-on:back="onELementBackEmit" />
          <!-- 视频 -->
          <LLearnVideo v-if="ELEMENT_TYPES.VIDEO === SOURCE_TO_ELEMENT[currentELementType] && element"
            :options="{
              autoplay: true,
              hidePlayBtn: false,
              canstop: true,
              vid: element.attrs.videoId,
            }" 
            @back="onELementBackEmit" @submit="onSubmit" />
          <!-- 音频 -->
          <LLearnAudio
            v-if="ELEMENT_TYPES.AUDIO === SOURCE_TO_ELEMENT[currentELementType] && element"
            @back="onELementBackEmit"
            @submit="onSubmit" />
          <!-- 试卷 -->
          <LLearnExam v-if="ELEMENT_TYPES.EXAM === SOURCE_TO_ELEMENT[currentELementType]" @submit="onSubmit" />
          <!-- 轮播图 -->
          <LLearnSwiper v-if="ELEMENT_TYPES.PICTURES === SOURCE_TO_ELEMENT[currentELementType]
            " @submit="onSubmit" />
          <!-- 学习通知-大复习指读-学习 -->
          <LLearnVideo :options="{
            vid: element.resource,
            autoplay: true,
          }" @ended="onRouteBack" v-if="ELEMENT_TYPES.PREVIEW_VIDEO ===
    SOURCE_TO_ELEMENT[currentELementType] && element
    " />
          <!-- 学习通知-小说录音-学习 -->
          <LLearnAudio v-if="ELEMENT_TYPES.PREVIEW_AUDIO ===
            SOURCE_TO_ELEMENT[currentELementType]
            " @ended="onRouteBack" />
          <!-- 读音游戏 -->
          <LGamePronunciation
            v-if="ELEMENT_TYPES.PRONUNCIATION_GAME === SOURCE_TO_ELEMENT[currentELementType]"
            @submit="onSubmit"
          />
          <!-- 指读 -->
          <LLearnPointRead
            v-if="ELEMENT_TYPES.POINT_READ === SOURCE_TO_ELEMENT[currentELementType]"
            @submit="onSubmit"
          />
          <!-- 默读 -->
          <LLearnSilenceRead
            v-if="ELEMENT_TYPES.SILENCE_READ === SOURCE_TO_ELEMENT[currentELementType]"
            @submit="onSubmit"
          />
          <!-- 讲解与理解 -->
          <LLearnExplainAndUnderstand
            v-if="ELEMENT_TYPES.EXPLAIN_AND_UNDERSTAND === SOURCE_TO_ELEMENT[currentELementType]"
            :options="{
              autoplay: true,
              hidePlayBtn: false,
              canstop: true,
              vid: element?.attrs?.videoId,
            }" 
            @back="onELementBackEmit"
            @submit="onSubmit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LLearnTitle from './components/l-learn-title'
import LLearnDesign from '@/components/l-learn-design'
import {
  LLearnAudio,
  LLearnQuestionAnswer,
  LLearnSwiper,
  LLearnVideo,
  LLearnExam,
  LGamePronunciation,
  LLearnPointRead,
  LLearnSilenceRead,
  LLearnAudioSort,
  LLearnExplainAndUnderstand,
} from './elements'
import Study2Model from '@/models/study2'
import { createNamespacedHelpers } from 'vuex'
import elementTypes from './minxin/elementTypes'
import LScore from './components/l-score'
import LRate from './components/l-rate'
import TIPS from '@/constants/tip'
const { mapGetters, mapMutations, mapActions } =
  createNamespacedHelpers('course')
const study2 = new Study2Model()

export default {
  components: {
    LLearnTitle,
    LLearnAudio,
    LLearnQuestionAnswer,
    LLearnSwiper,
    LLearnVideo,
    LLearnExam,
    LLearnDesign,
    LGamePronunciation,
    LLearnPointRead,
    LLearnSilenceRead,
    LLearnAudioSort,
    LLearnExplainAndUnderstand,
  },
  mixins: [elementTypes],
  provide() {
    return {
      resizeStatus: this.swiperResize,
    }
  },
  data() {
    return {
      currentELementType: '',
      swiperResize: {
        status: false,
      },
    }
  },
  created() {
    this._initELementData()
  },
  watch: {
    '$route.params.elementType'(to, form) {
      if (to != form) {
        this._initELementData()
      }
    },
  },
  computed: {
    ...mapGetters(['element', 'lesson']),
    // 问答题
    isQuestionAndAnswer() {
      return (
        [
          this.ELEMENT_TYPES.AUDIO_TEST,
          this.ELEMENT_TYPES.AUDIO_READ,
          this.ELEMENT_TYPES.ABC_EXPLAIN_TEST,
          this.ELEMENT_TYPES.ABC_OPTIONS_TEST,
          this.ELEMENT_TYPES.EXPLAIN_TEST,
          this.ELEMENT_TYPES.LISTEN_REPEAT_TEST,
          this.ELEMENT_TYPES.SELF_READING_TEST,
        ].indexOf(this.SOURCE_TO_ELEMENT[this.currentELementType]) > -1
      )
    },
    // 小说录音（整看提示、大复习指导）提示数据
    isPreviewStudy() {
      return (
        [
          this.ELEMENT_TYPES.STUDY_MESSAGE,
          this.ELEMENT_TYPES.PREVIEW_VIDEO,
          this.ELEMENT_TYPES.PREVIEW_AUDIO,
        ].indexOf(this.SOURCE_TO_ELEMENT[this.$route.params.elementType]) > -1
      )
    },
  },
  methods: {
    ...mapMutations([
      'SET_CURRENT_ELEMENT',
      'RESET_ELEMENT',
      'SET_ELEMENT_SUBMIT_STATUS',
      'SET_HIGH_WORD',
      'SET_STATUS',
    ]),
    ...mapActions(['STUDY_START', 'STUDY_FINISH', 'PREVIEW_FINISH']),
    async studyNoticeList() {
      this.SET_CURRENT_ELEMENT({
        ELEMENT_TYPE: this.SOURCE_TO_ELEMENT[this.currentELementType],
        id: this.$route.query.id,
        resource: this.$route.query.resource,
        name: this.$route.query.name,
      })
    },
    // 大复习只读学习完毕返回路由
    onRouteBack() {
      console.log('整听整看结束：', this.element)
      this.PREVIEW_FINISH({ id: this.element.id }).then(() => {
        this.$router.go(-1)
      }).catch(err => {
        console.log('整听整看结束失败：', `${this.element.id}-${err}`)
      })
    },
    // 元素触发返回
    onELementBackEmit() {
      this._back()
    },
    // 点击title返回
    onTitleBackEmit() {
      // 除跟读、自读之外的元素 返回需要拦截
      if (
        ([
          this.ELEMENT_TYPES.SELF_READING_TEST,
          this.ELEMENT_TYPES.LISTEN_REPEAT_TEST,
        ].indexOf(this.SOURCE_TO_ELEMENT[this.currentELementType]) < 0 &&
          document.querySelector('video')) ||
        this.ELEMENT_TYPES.AUDIO ===
        this.SOURCE_TO_ELEMENT[this.currentELementType]
      ) {
        this.SET_CURRENT_ELEMENT({
          ...this.element,
          isCallBack: Math.random(),
        })
      } else {
        // 返回
        this._back()
      }
    },
    // 点击小说录音的学习或者大复习指读的视频播放
    onStudy(data) {
      this.currentELementType = data.info.type
      this.SET_CURRENT_ELEMENT({
        ELEMENT_TYPE: this.SOURCE_TO_ELEMENT[this.currentELementType],
        ...data.info,
      })

      this.$router.push({
        path: `/learning/${this.currentELementType}?type=${this.$route.query.type
          }&id=${data.info.id}&key=${data.key}&t_s=${Date.now()}`,
      })
    },
    // 开启并获取元素详情信息
    async getElementDetail() {
      try {
        let eleData = await this.STUDY_START({
          elementId: this.$route.query.dataId,
        })
        // 当前元素类型
        this.currentELementType = eleData.type
        console.log(
          '当前元素：',
          this.SOURCE_TO_ELEMENT[this.currentELementType],
          this.currentELementType
        )

        let tempTimer = setTimeout(() => {
          this.SET_CURRENT_ELEMENT({
            ELEMENT_TYPE: this.SOURCE_TO_ELEMENT[this.currentELementType],
            isSubmit: false,
            ...eleData,
          })

          clearTimeout(tempTimer)
          tempTimer = null
        }, 20)
      } catch (error) {
        this.$lPrompt({
          message: error.msg || error.message,
          successFn: () => {
            window.location.replace(`/level?stage=${this.lesson.stage}`)
          },
        })
      }
    },
    _nextNode(node) {
      let route = {
        path: `/level`,
      }

      if (node) {
        route.path = `/learning/${node.type}`
        route.query = {
          id: this.$route.query.id,
          preId: this.$route.query.preId,
          dataId: node.id,
        }
      } else {
        route.query = {
          stage: this.lesson.stage,
        }
      }

      return route
    },
    // 提交记录
    async onSubmit(postdata = {}) {
      this._finish(postdata)
    },
    // 开启节点
    async _startNext(elementId) {
      return await this.STUDY_START({ elementId })
    },
    // 完成，并且下一节点
    async onNext(params = {}) {
      this._finish(params)
    },
    // 提交本元素记录
    async _finish(postdata) {
      console.log('学完了，submit', postdata)
      this.$lLoading.show()

      try {
        // 1、上传记录
        let uploadResData = await this.STUDY_FINISH({
          elementId: this.$route.query.dataId,
        })
        // 1.1 本关卡最后一个元素完成
        const isLevelDone = uploadResData.done > 0

        // 2.1 获取下一个节点数据
        let nextRes = await study2.nextNode({
          id: this.$route.query.id,
          lessonId: this.$route.query.preId,
        })
        const nextResData = nextRes.data

        // 2.2 组装下一个节点路由
        const nextRoute = this._nextNode(nextResData)

        // 3、组装弹窗
        const message = this._tipCompose(this.element, uploadResData)
        console.log('组装弹窗：', message, nextRoute.path)
        this.$lPrompt({
          message: message ? message : TIPS.NEW_CONTENT,
          cancelTxt: isLevelDone ? '' : this.$locale.休息一下,
          successTxt: isLevelDone ? this.$locale.休息一下 : nextResData ? this.$locale.继续闯关 : this.$locale.确定,
          successFn: async () => {
            // 4、下一节点&关卡完成，强制休息
            if (isLevelDone) {
              this._back()
            } else {
              window.location.replace(
                `${nextRoute.path}?${this._parameter(nextRoute.query)}`
              )
            }
          },
          cancelFn: isLevelDone ? '' : () => {
            this._back()
          },
        })
        this.SET_ELEMENT_SUBMIT_STATUS(true)
        this.$lLoading.hide()
      } catch (err) {
        this.$lPrompt({
          message: err.message,
          successTxt: this.$locale.确定,
          successFn: function () {
            //
          },
        })
      }
    },
    _tipCompose(element, result) {
      if (this.SOURCE_TO_ELEMENT[this.element.type] ===
        this.ELEMENT_TYPES.LISTEN_REPEAT_TEST) {
        return '你真棒！让我们进入下一个内容吧'
      }
      if (this.SOURCE_TO_ELEMENT[this.element.type] === this.ELEMENT_TYPES.POINT_READ) {
        return this.$createElement(LRate, {
          props: {
            score: result.star,
          },
        })
      }
      else if (this.isQuestionAndAnswer) {
        return this.$createElement(LScore, {
          props: {
            element: element,
            result: result,
          },
        })
      }
      else if (this.SOURCE_TO_ELEMENT[this.element.type] === this.ELEMENT_TYPES.AUDIO_SORT
        || this.SOURCE_TO_ELEMENT[this.element.type] === this.ELEMENT_TYPES.EXPLAIN_AND_UNDERSTAND
      ) {
        return this.$createElement(LScore, {
          props: {
            element: element,
            result: result,
          },
        })
      }
      else {
        return result.msg
      }
    },
    _initELementData() {
      this.currentELementType = this.$route.params.elementType
      // 小说录音、整看提示、大复习指读
      if (this.isPreviewStudy) {
        this.studyNoticeList()
        // 获取数据
      } else {
        // 获取元素详情信息
        this.getElementDetail()
      }
    },
    //参数转换
    _parameter(query) {
      let url = ''
      for (const key in query) {
        if (query[key]) {
          url += '&' + key + '=' + query[key]
        }
      }
      return url
    },
    // 返回
    _back() {
      let route = {
        path: '/lesson',
        query: {
          id: this.$route.query.id,
          dataId: this.$route.query.preId,
        },
      }

      this.$router.replace(route)
    },
  },
  destroyed() {
    // 重置当前元素
    this.RESET_ELEMENT()
    this.currentELementType = null
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'

.learn-page
  width 100%
  height 100%
</style>
